import React from 'react'
import MassUpdate from '@commonComponents/massUpdate'
import { FIELD_NAMES_MERCH_IMPORT,FIELD_NAMES_MERCH_EXPORT } from './constants'
import { itemActions } from '../../../reducer/ItemSlice'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'


const MassUpdateDMS = () => {
    const {isImportShipment, isRFI} = useCurrentShipmentType()
    return (
        <MassUpdate
            countryCode={'NL'}
            fieldNameList={isImportShipment?FIELD_NAMES_MERCH_IMPORT:FIELD_NAMES_MERCH_EXPORT}
            updateInvoiceHeader={itemActions.updateInvoiceHeader}
            updateMerchandiseItem={itemActions.updateMerchandiseItem}
            massUpdateAtInvoiceLevel={itemActions.massUpdateAtInvoiceLevel}
            massUpdateAtMultiInvoiceLevel={itemActions.massUpdateAtMultiInvoiceLevel}
            isMassUpdateDisabled={isRFI}
        />
    )
}

export default MassUpdateDMS